import api from './api';

export const buscarCodigoPostal = async (cp) => {
  try {
    const response = await api.get(`/codigos-postales/${cp}`);
    return response.data;
  } catch (error) {
    console.error('Error al buscar código postal:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Código postal no encontrado'
    };
  }
};